import React from 'react'
import tw from 'tailwind-styled-components'
import {Icon} from '@components/common/base/icon'
import {cn} from '../../../../../containers/html-utils'
import {TablerIcons} from '../../../../common/icon-tabler/icon-tabler'

interface TabSwitcherItemProps {
  icon?: TablerIcons
  title: string
  active?: boolean
  onClick?: () => void
}

const TwSwitcherItem = tw.div`
  flex
  items-center
  gap-4
  cursor-pointer
  px-6
  py-4
  rounded-4
  text-sm-regular
`

export const TwTabSwitcherContainer = tw.div`
  flex
  gap-2
  p-2
  bg-background-subtask-open
  rounded-6
  w-fit
`

export const TabSwitcherItem = (props: TabSwitcherItemProps) => {
  const {icon, title, active, onClick} = props
  return (
    <TwSwitcherItem
      className={cn(
        active ? 'bg-primary text-action-default' : 'text-secondary'
      )}
      onClick={onClick}
    >
      {icon && (
        <Icon icon={icon} color={active ? 'action-default' : 'secondary'} />
      )}
      {title}
    </TwSwitcherItem>
  )
}
